import m from "../../geodata/es2015/unRegionsLow";
window.am4geodata_unRegionsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/unRegionsLow.js
// module id = null
// module chunks = 